import type { RouteRecordRaw } from 'vue-router/auto'

// 👉 Redirects - 별도의 리다이렉트는 guards.ts에서 처리
export const redirects: RouteRecordRaw[] = []

export const routes: RouteRecordRaw[] = [
  // 루트 경로 리다이렉트
  {
    path: '/',
    name: 'root',
    redirect: '/dashboard',
  },
]
